import { api } from "./client";

export type Environment = "DEVELOPMENT" | "STAGING" | "PRODUCTION";

export interface App {
  id: string;
  name: string;
  description: string | null;
  url: string;
  iconUrl: string | null;
  logoUrl: string | null;
  environment: Environment;
  isDefault: boolean;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAppInput {
  name: string;
  description?: string;
  url: string;
  iconUrl?: string;
  logoUrl?: string;
  environment?: Environment;
  isDefault?: boolean;
  metadata?: Record<string, unknown>;
}

export type UpdateAppInput = Partial<CreateAppInput>;

export interface AppUser {
  id: string;
  email: string;
  displayName: string | null;
}

export const appsApi = {
  list: () => api.get<App[]>("/apps").then((r) => r.data),
  get: (id: string) => api.get<App>(`/apps/${id}`).then((r) => r.data),
  create: (input: CreateAppInput) => api.post<App>("/apps", input).then((r) => r.data),
  update: (id: string, input: UpdateAppInput) =>
    api.patch<App>(`/apps/${id}`, input).then((r) => r.data),
  remove: (id: string) => api.delete(`/apps/${id}`).then(() => undefined),
  detectIcon: (id: string) =>
    api.post<{ iconUrl: string }>(`/apps/${id}/detect-icon`).then((r) => r.data),
  listUsers: (id: string) => api.get<AppUser[]>(`/apps/${id}/users`).then((r) => r.data),
  setUsers: (id: string, userIds: string[]) =>
    api.put<AppUser[]>(`/apps/${id}/users`, { userIds }).then((r) => r.data),
};
